import Backbone from 'backbone';

export default Backbone.Model.extend({
    defaults: {
        app_id                : 0,
        project_key           : '',
        priority              : '',
        issue_type            : '',
        reporter              : '',
        is_auto               : false,
        auto_resolve          : false,
        feedback_type         : '',
        sync_status_to_jira   : false,
        sync_status_from_jira : false,
        sync_comment_to_jira  : false,
        sync_comment_from_jira: false,
        status_sync_delete    : false,
        is_disabled           : false
    },

    isConnected: function() {
        return this.get('project_key') ? true : false;
    }
});